export { default as AppInsightsProvider } from './AppInsightsProvider';
export { appInsights, withAppInsights } from './app-insights-config';
